import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const HighwayIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Highway - wide road with multiple lanes */}
    <path d="M3 4l3 16" />
    <path d="M21 4l-3 16" />
    <path d="M3 4h18" />
    <path d="M6 20h12" />
    <path d="M9 4l1 16" />
    <path d="M15 4l-1 16" />
    <path d="M12 6v2" />
    <path d="M12 11v2" />
    <path d="M12 16v2" />
  </svg>
);
